import { ToastOptions } from "react-toastify";


export const ToastConfig = {
  position: "top-center",
  autoClose: 2800,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  progress: undefined,
  theme: "dark",
} as ToastOptions;